import {
	mapState,
	mapMutations
} from 'vuex'
import {
	cancel
} from '@/utils/api'
import constants from './common/constants'
import ssoUtils from './utils/ssoUtils'


const mixin = {
	computed: {
		constants() {
			return constants
		},
		checkLogin() {
			if (sessionStorage.getItem('client_id') != null) {
				return true
			} else {
				return false
			}
		},
		isShowLoad() {
			return this.$store.state.showLoad
		}
	},
	data() {
		return {
			isInit: false
		}
	},
	methods: {
		goLogin(loginPath, toPath) {

			// 需要判断是否在客户端内，如果是则唤起登录
			if (window.qt) {
				// 需要添加遮罩层
				this.showload(true)
				ssoUtils.requestLoginSession()
			} else {
				this.$router.push({
					path: loginPath,
					query: {
						to: toPath
					}
				})
			}
		},
		...mapMutations({
			showload: 'UPDATA_LOAD'
		})
	},
	mounted() {
		this.isInit = true
		this.showload(false)
	},
	destroyed() {
		if (this.$alert) {
			this.$alert.hide()
		}
		if (this.$confirm) {
			this.$confirm.hide()
		}
		this.showload(false)
	}
}

export default mixin



// WEBPACK FOOTER //
// ./src/mixin.js